import { Grid } from "antd";
import { useTranslation } from "react-i18next";
import StrengthImage from "../../../../assets/images/body/strengths.png";

import { Title } from "../../../../components";
import { StrengthItem } from "./components";
import styles from "./style.module.scss";

const StrengthSection = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const getPositionStyle = (index: number) => {
    let positions: {
      top?: string;
      right?: string;
      bottom?: string;
      left?: string;
    }[] = [];
    if (screens.xxl)
      //1920
      positions = [
        { top: "100px", right: "250px" },
        { top: "169px", left: "176px" },
        { top: "499px", right: "210px" },
        { top: "574px", left: "289px" },
      ];
    else if (screens.xl)
      //1440
      positions = [
        { top: "105px", right: "156px" },
        { top: "174px", left: "103px" },
        { top: "504px", right: "128px" },
        { top: "589px", left: "184px" },
      ];
    else if (screens.lg)
      //1024
      positions = [
        { top: "86px", right: "29px" },
        { top: "155px", left: "36px" },
        { top: "485px", right: "60px" },
        { top: "560px", left: "142px" },
      ];
    else if (screens.md)
      //744
      positions = [
        { top: "13px", right: "49px" },
        { top: "71px", left: "28px" },
        { top: "299px", right: "52px" },
        { top: "364px", left: "61px" },
      ];
    else if (screens.sm)
      //512
      positions = [
        { top: "0", right: "24px" },
        { top: "69px", left: "24px" },
        { top: "265px", right: "30px" },
        { top: "304px", left: "24px" },
      ];
    else if (screens.xs)
      //375
      positions = [
        { top: "31px", right: "20px" },
        { top: "19px", left: "20px" },
        { top: "216px", right: "20px" },
        { top: "235px", left: "20px" },
      ];
    return positions[index];
  };
  const { t } = useTranslation();
  return (
    <div className={styles.strengthContainer} id={"strength"}>
      <Title text={t("expertise.title")} shadowText={t("expertise.shadow")} />
      <div className={styles.imageContainer}>
        <img
          src={StrengthImage}
          className={styles.bgImage}
          alt={t("expertise.title")}
        />
        <StrengthItem
          containerStyle={getPositionStyle(0)}
          subtitle={t("expertise.subtitle0")}
          desc={t("expertise.desc0")}
        />
        <StrengthItem
          containerStyle={getPositionStyle(1)}
          subtitle={t("expertise.subtitle1")}
          desc={t("expertise.desc1")}
        />
        <StrengthItem
          containerStyle={getPositionStyle(2)}
          subtitle={t("expertise.subtitle2")}
          desc={t("expertise.desc2")}
        />
        <StrengthItem
          containerStyle={getPositionStyle(3)}
          subtitle={t("expertise.subtitle3")}
          desc={t("expertise.desc3")}
        />
      </div>
    </div>
  );
};

export default StrengthSection;
